import { cn, en } from "./common";
import { loCn, loEn } from "./login";
import { storeCn, storeEn } from "./stores/index";
import { orderCn, orderEn } from "./orders";
import { productCn, productEn } from "./products";
import { setCn, setEn } from "./settingFinancial";
const resources = {
  en: {
    translation: {
      ...en,
      ...loEn,
      ...storeEn,
      ...orderEn,
      ...productEn,
      ...setEn,
    },
  },
  zh: {
    translation: {
      ...cn,
      ...loCn,
      ...storeCn,
      ...orderCn,
      ...productCn,
      ...setCn,
    },
  },
};
export default resources;
